import i18n from '@/utils/i18n';
// 换房原因枚举
export const replaceReasonEnum = [{
  code: 'needRepair',
  name: i18n.t("utilsEnum.roomInNeedOfRepair")
}, {
  code: 'guestDemand',
  name: i18n.t("utilsEnum.guestRequest")
}, {
  code: 'hotelCheckDemand',
  name: i18n.t("utilsEnum.hotelRowRoomDemand")
}, {
  code: 'other',
  name: i18n.t("common.other")
}]
// 工单状态枚举
export const workOrderStatus = [
  {
    code: 1,
    name: i18n.t("common.toBeProcessed")
  },
  {
    code: 2,
    name: i18n.t("utilsEnum.inProcess")
  },
  {
    code: 5,
    name: i18n.t("common.completed")
  },
  {
    code: 7,
    name: i18n.t("utilsEnum.alreadyEnded")
  }
]
// 夜审步骤枚举
export const nightAuditItemList = [{
  label: i18n.t("utilsEnum.storeOrderPreArrivalHasNotBeenChecked"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.leaveTheRoomForInspectionToday"),
  contents: [],
  isActive: false
},
{
  label: i18n.t("utilsEnum.generateRoomChargesInTheRoom"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.cleanRoomToDirtyRoom"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.switchingDay"),
  contents: [],
  isActive: false
  }]
  // 夜审步骤枚举
export const nightAuditItemList_gray_env = [{
  label: i18n.t("utilsEnum.preArrivalNoShowRoomListPending"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.preSeparationIsNotSeparated"),
  contents: [],
  isActive: false
},
{
  label: i18n.t("utilsEnum.allRoomChargesAreGeneratedAndRecordedInTheAccount"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.roomChange"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.generateCureReport"),
  contents: [],
  isActive: false
}, {
  label: i18n.t("utilsEnum.switchingDay"),
  contents: [],
  isActive: false
  }]
// 产品类型枚举
export const productionTypeList = [{
  code: 1,
  name: i18n.t("common.commonProduct")
}, {
  code: 2,
  name: i18n.t("common.freeRoomProducts")
}, {
  code: 3,
  name: i18n.t("utilsEnum.shopHourRoom")
}, {
  code: 4,
  name: i18n.t("utilsEnum.onlineHourRoom")
}, {
  code: 5,
  name: i18n.t("utilsEnum.presaleFullDayRoomProduct")
}, {
  code: 6,
  name: i18n.t("utilsEnum.presaleClockRoomProduct")
}]
